export interface TalentBySpecialityContent {
  hero: {
    header: string;
    suheader: string;
  };
  intro: string;
  specialties: {
    categoryTitle: string;
    items: {
      title: string;
      content: string;
    }[];
  }[];
}

export const content: TalentBySpecialityContent = {
  hero: {
    header: "Talent by Specialty",
    suheader:
      "We source: WebApps, Mobile Apps, DevSecOps, Public/Private Cloud, Data Center, Networking, CyberSecurity, OT/ICT",
  },
  intro:
    "We staff talent specializing in Private Cloud, Public Cloud, SaaS Platforms, App developer, DevSecOps, Infrastructure and CyberSecurity. ",
  specialties: [
    {
      categoryTitle: "Server",
      items: [
        {
          title: "Linux Server Engineers",
          content:
            "RedHat (RHEL), Ubuntu, Debian, Fedora, CentOS, HPC, others  ",
        },
        {
          title: "Windows Server Engineers",
          content:
            "Windows Server (2003022), AD, Sharepoint, Microsoft 365, HPC, others  ",
        },
        {
          title: "Storage Engineers",
          content:
            "NetApp, Dell EMC, HPE, IBM, Pure, Veritas, Hitachi Vantara, others",
        },
      ],
    },
    {
      categoryTitle: "Virtualization",
      items: [
        {
          title: "Virtualization Engineers",
          content: "vmware, Hyper-V, KVM, RHEV, XenServer, Nutanix, others ",
        },
        {
          title: "HyperConverged Infrastructure Engineers",
          content:
            "HCI – Nutanix, HPE, Dell EMC VxRail, Cisco HyperFlex, others ",
        },
      ],
    },
    {
      categoryTitle: "Network",
      items: [
        {
          title: "Network Engineers",
          content:
            "LAN, WAN, Wireless, Cisco, Juniper, HPE, Palo Alto, Extreme, Fortinet, others",
        },
        {
          title: "SDN Software Defined Network Engineers",
          content:
            "Cisco ACI, VMware NSX, Arista, Juniper Contrail, Cumulus, others ",
        },
        {
          title: "SD-WAN Engineers",
          content:
            "Viptella, VeloCloud, Juniper, Silver Peak, Meraki, Citrix, Aruba, others ",
        },
        {
          title: "Load Balancing Engineers ",
          content: "F5, Riverbed, HP, Citrix ADC, others ",
        },
      ],
    },
    {
      categoryTitle: "Security",
      items: [
        {
          title: "Security Infrastructure Engineers",
          content:
            "NG Firewall, IPS, IDS, IAM, Palo Alto, Fortinet, Juniper, Firepower",
        },
        {
          title: "Security Governance/Risk/Compliance Specialists",
          content:
            "GRC Framework specialists, Risk Compliance Practitioners, CISO.  Includes expertise with ISO, NIST, SOC, NERC-CIP, HIPAA, GDPR, FISMA, PCI-DSS, others",
        },
        {
          title: "Security Vulnerability Specialists",
          content:
            "PenTest Penetration Testing, Vulnerability Assessment, Blue/Red Teams",
        },
      ],
    },
    {
      categoryTitle: "Cloud",
      items: [
        {
          title: "AWS Developers and Engineers ",
          content:
            "EC2, S3, Lambda, RDS, DynamoDB, VPC, hybrid security, others  ",
        },
        {
          title: "Azure Developers and Engineers ",
          content:
            "Compute, Storage, Active Directory, CDN, Data Factory, SQL, CosmosDB, hybrid security, others",
        },
        {
          title: "GCP Developers and Engineers",
          content:
            "Compute, Storage, Cloud BigTable, DNS, CDN, BigQuery, AutoML, hybrid security, others",
        },
        {
          title: "IBM Cloud Developers and Engineers ",
          content: "IBM Cloud - Compute, Storage, DB, Networking, IOT",
        },
        {
          title: "Oracle Cloud Developers and Engineers",
          content:
            "Cloud Native, Cloud BCDR, High Performance Computing (HPC), Data Lakehouse",
        },
      ],
    },
    {
      categoryTitle: "AppDev",
      items: [
        {
          title: "Front End Engineers",
          content: "JavaScript, HTML, CSS, React, Angular, Svelte",
        },
        {
          title: "Back End Engineers",
          content:
            "Python, Java, C, C++, Go, Django, Flask, Laravel, Spring Boot, others",
        },
        {
          title: "DevSecOps Admins & Engineers ",
          content:
            "Docker, Kubernetes, Ansible, Chef, Bamboo, BitBucket, Jira, Databricks, PowerBI, Tableau, Python, Terraform (IaC), Jenkins, ELK Stack, SumoLogic, Prometheus, Nagios, others ",
        },
      ],
    },
    {
      categoryTitle: "Mobile",
      items: [
        {
          title: "IOS Mobile Apps Developers",
          content: "Swift, Objective-C, and SwftUI",
        },
        {
          title: "Android Mobile Apps Developers",
          content: "Java, Kotlin and others.",
        },
        {
          title: "Cross Platform Apps Developers",
          content: "React Native, Ionic, Flutter, Cordova and others.",
        },
      ],
    },
    {
      categoryTitle: "Low Code",
      items: [
        {
          content:
            "Appian, Salesforce Lightning, Mendix, PowerApps, Outsystems, Quickbase, Zoho Creator, Caspio, Xplenty, Oracle APEX, Quick Base, Kissflow, others ",
          title: "Low Code Developers",
        },
      ],
    },
    {
      categoryTitle: "Data Engineers",
      items: [
        {
          title: "Data Scientists",
          content: "Python, MATLAB, and others",
        },
        {
          content:
            "AI Artificial Intelligence, ML Machine Learning, Deep Learning, Computer Vision, TensorFlow, NLP, PyTorch, others ",
          title: "AI/ML Specialists",
        },
      ],
    },
    {
      categoryTitle: "OT/ICT ",
      items: [
        {
          title: "OT/ICT Engineers",
          content:
            "Operational Technologies, Industrial Controls Technologies, SCADA, DCS, IOT/IIOT Sensors, LAN, WAN, Security controls, Secure Internet Access, IT/OT Hybrid, others ",
        },
      ],
    },
    {
      categoryTitle: "Video Streaming",
      items: [
        {
          title: "Video Streaming Engineers",
          content:
            "Build and maintain systems that deliver high-quality video content. Work with encoding, streaming protocols, and platform integrations. Drive innovation in digital video delivery.",
        },
        {
          title: "Video Streaming Site Reliability Engineers (SREs)",
          content:
            "Ensure streaming platforms are fast, reliable, and available around the clock. Automate monitoring, troubleshoot issues, and maintain uptime under high traffic. Keep millions of viewers engaged without interruptions.",
        },
        {
          title: "Video Streaming DevOps Specialists",
          content:
            "Bridge development and operations to deploy streaming applications efficiently. Automate pipelines, manage cloud infrastructure, and scale delivery systems. Enable continuous improvement for high-performance video services.",
        },
      ],
    },
  ],
};
